import React from 'react';
import { Row } from 'react-bootstrap';
import {
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';

/** Φτιάξε το where για το graphql από τις τιμές φίλτρου */
export function buildWhereFromFilterValues(values): string {
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ name: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
  }
  return JSON.stringify(where);
}

export const Filters = ({ onChange, initialValues }) => {
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput as={FormCol} name="searchText" label={t('Αναζήτηση')} type="search" />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} />
      </Row>
    </FormFilterCard>
  );
};
